import React from 'react';

function Profile() {
  return <div className="container mt-5"><h2>User Profile</h2></div>;
}

export default Profile;